<style lang="scss" src="./index.scss" />
<template>
  <div class="wgt-member-task">
    <!-- 任务列表 -->
    <div class="wgt-bd">
      <div
        v-if="taskList.length > 0"
        v-for="(task, index) in taskList"
        :key="`task-item-${index}`"
        class="task-item"
      >
        <!-- 左侧积分显示 -->
        <div class="task-points">
          <span class="points-value" :style="{ color: value.pointsColor || '#5875F8' }">
            + {{ task.points }}
          </span>
        </div>

        <!-- 中间内容区 -->
        <div class="task-content">
          <div class="task-title">{{ task.task_name }}</div>
          <div class="task-desc">{{ task.task_description }}</div>
        </div>

        <!-- 右侧按钮 -->
        <div class="task-action">
          <div
            class="action-btn"
            :style="{
              backgroundColor: value.buttonBackgroundColor || '#5875F8',
              color: value.buttonTextColor || '#ffffff'
            }"
          >
            {{ task.nav_button_text || '去完成' }}
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        暂无任务
      </div>
    </div>
  </div>
</template>

<script>
import config from './config'
import { getTaskList } from '@/api/point'

export default {
  name: 'MemberTask',
  wgtName: '会员任务',
  wgtDesc: '',
  wgtIcon: 'wgt-member-info',
  wgtType: 2,
  wgtTem: 1, // 0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      taskList: [],
    }
  },
  created() {
    this.fetchTaskList()
  },
  methods: {
    async fetchTaskList() {
      try {
        const res = await getTaskList({
          page: 1,
          page_size: 50,
          is_show: '1'
        })

        if (res.data && res.data.data.list) {
          this.taskList = res.data.data.list
        }
      } catch (error) {
        console.error('获取任务列表失败:', error)
        this.taskList = []
      }
    }
  }
}
</script>
